import type { FC } from 'react';
import { styled } from 'styled-components';

import { useTranslation } from '~/hooks';

interface ApplyButtonProps {
  onClick?: () => void;
}

const StyledBtn = styled.span`
  background: ${({ theme }) => theme.colors.primary.normal};
  margin: 0;
  text-align: center;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  font-size: 0.8125rem;
  font-family: 'Red Hat Display', sans-serif;
  font-weight: 700;
  width: 100%;
  color: rgb(255, 255, 255);
  line-height: 1.5rem;
  padding: 1rem 2rem;
  transition: background 0.2s;
  &:hover {
    background: ${({ theme }) => theme.colors.primary.dark};
  }
  &:active {
    background: ${({ theme }) => theme.colors.primary.darker};
  }
`;

export const MissionApplyButton: FC<ApplyButtonProps> = ({ onClick }) => {
  const t = useTranslation();

  return <StyledBtn onClick={onClick}>{t('missions.apply')}</StyledBtn>;
};
